<template>
  <!-- 填充 -->
  <AttrImage
    label="预览图"
    class="mt-2.5"
    :base64="preview"
    :disabled="attrDisabled == 'not-image'"
    @change="(image: string) => onImageUpdate(image,'appWidgetPreview')"
    @delete="() => onImageDelete('appWidgetPreview')"
  />

  <AttrGroup title="选择小组件">
    <AttrSelect
      label="小组件"
      :value="shape.attrs.appWidgetID"
      :disabled="!!attrDisabled"
      :options="byDeviceAppWidgetOptions"
      @change="onWidgetIdChange"
    />
  </AttrGroup>
</template>

<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { PropType, computed } from 'vue';
import { useEditorStore } from '@/store/use-editor-store';
import { ResourceKey } from '@/services/shape/attributes';
import { useWatchfaceStore } from '@/store/use-watchface-store';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});

const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);

// const shapeOptions = [
//   { label: '正方形', value: 'Square' },
//   { label: '长方形', value: 'Rectangle' },
//   { label: '圆形', value: 'Circle' }
// ];
// const colorOptions = [
//   {
//     label: '深色(彩色',
//     value: 'Dark'
//   },
//   {
//     label: '浅色(单色',
//     value: 'Light'
//   }
// ];
// const displayOptions = [
//   {
//     label: '日出日落',
//     value: 'sunRiseAndSet'
//   },
//   {
//     label: '心率',
//     value: 'heartRate'
//   },
//   {
//     label: '天气',
//     value: 'wheather'
//   }
// ];
// const onShapeChange = (val: AppWidgetAttribute['shape']) => {
//   props.shape.setAttrs({
//     shape: val
//   });
// };
// const onColorChange = (val: AppWidgetAttribute['colorMode']) => {
//   props.shape.setAttrs({
//     colorMode: val
//   });
// };
// const onDisplayChange = (val: AppWidgetAttribute['currentDisplay']) => {
//   props.shape.setAttrs({
//     currentDisplay: val
//   });
// };
const onWidgetIdChange = (val: string) => {
  props.shape.setAttrs({
    appWidgetID: val
  });
};
const watchfaceStore = useWatchfaceStore();

const appWidgetIDOptions = [
  {
    value: 'WidgetSubType_WEATHER_LIGHT_RECT_HOURLY',
    oldValue: 'weatherRectangleLightHourly',
    label: '天气-亮色-10643',
    excludeDevice: ['O66', 'N67', 'P65']
  },
  {
    value: 'WidgetSubType_WEATHER_DARK_RECT_HOURLY',
    oldValue: 'weatherRectangleDarkHourly',
    label: '天气-暗色-10387',
    excludeDevice: ['O66', 'P65']
  },
  {
    value: 'WidgetSubType_HEART_RATE_LIGHT_RECT_SPLASH',
    oldValue: 'heartRateRectangleLight',
    label: '心率散点图-亮色-4498',
    excludeDevice: ['N67', 'O62', 'O66', 'O63']
  },
  {
    value: 'WidgetSubType_HEART_RATE_DARK_RECT_SPLASH',
    oldValue: 'heartRateRectangleDark',
    label: '心率散点图-暗色-4242',
    excludeDevice: ['O63', 'P65']
  },
  {
    value: 'WidgetSubType_FITNESS_LIGHT_RECT_STAND',
    oldValue: 'fitnessRectangleLightStand',
    label: '站立-亮色-3476',
    excludeDevice: ['N67', 'O62', 'O66', 'O63', 'P65']
  },
  {
    value: 'WidgetSubType_FITNESS_DARK_RECT_STAND',
    oldValue: 'fitnessRectangleDarkStand',
    label: '站立-暗色-3220',
    excludeDevice: ['N67', 'O62', 'O66', 'O63']
  },
  {
    value: 'WidgetSubType_FITNESS_DARK_RECT_CALORIE',
    oldValue: 'fitnessRectangleDarkCalorie',
    label: '卡路里-暗色-3219',
    excludeDevice: ['O66']
  },
  {
    value: 'WidgetSubType_WEATHER_LIGHT_RECT_SUN',
    oldValue: 'weatherRectangleLightSun',
    label: '日出-亮色-10644',
    excludeDevice: ['N67', 'O62', 'O66', 'O63', 'P65']
  },
  {
    value: 'WidgetSubType_WEATHER_DARK_RECT_SUN',
    oldValue: 'weatherRectangleDarkSun',
    label: '日落-暗色-10388',
    excludeDevice: ['N67', 'O62', 'O66', 'O63', 'P65']
  },
  {
    value: 'WidgetSubType_CALENDAR_LIGHT_RECT_NEXT',
    oldValue: 'calenderRectangleLightNext',
    label: '下一个日程-亮色-18833',
    excludeDevice: ['N67', 'O62', 'O66', 'O63', 'P65']
  },
  {
    value: 'WidgetSubType_CALENDAR_DARK_RECT_NEXT',
    oldValue: 'calenderRectangleDarkNext',
    label: '下一个日程-暗色-18577',
    excludeDevice: ['N67', 'O62', 'O66', 'O63', 'P65']
  },
  {
    value: 'WidgetSubType_FITNESS_DARK_RECT_ACTIVITY',
    oldValue: 'fitnessRectangleDarkActivity',
    label: '活动时长-暗色-3221',
    excludeDevice: ['O66']
  },
  {
    value: 'WidgetSubType_FITNESS_DARK_RECT_STEP',
    oldValue: 'fitnessRectangleDarkStep',
    label: '活动步数-暗色-3218'
  },
  // { value: 'WidgetSubType_FITNESS_DARK_RECT_STEP', label: '步数' },
  // { value: 'WidgetSubType_FITNESS_DARK_RECT_CALORIE', label: '卡路里' },
  // { value: 'WidgetSubType_HEART_RATE_DARK_RECT_SPLASH', label: '心率' },
  // {
  //   value: 'WidgetSubType_FITNESS_DARK_RECT_ACTIVITY',
  //   label: '高强度活动时长'
  // },
  {
    value: 'WidgetSubType_SLEEP_DARK_RECT_LONG',
    label: '睡眠-8338',
    excludeDevice: ['O66', 'O63', 'O62', 'N67', 'P65']
  },
  {
    value: 'WidgetSubType_FITNESS_DARK_RECT_VITALITY',
    label: '活力指标-3217',
    excludeDevice: ['O62', 'O66', 'N67', 'P65']
  },
  {
    value: 'WidgetSubType_BLOOD_OXYGEN_DARK_RECT_SPLASH',
    label: '血氧-暗色-7314',
    includeDevice: ['P65']
    // 新增
  },

  {
    value: 'WidgetSubType_PRESSURE_DARK_RECT_LINE',
    label: '压力-暗色-6291',
    includeDevice: ['P65']
    // 新增
  }
];

const newAppWidgetIDOptions = [
  {
    value: 'WidgetSubType_FITNESS_DARK_RECT_VITALITY',
    label: '活力指标-暗色-3217'
  },
  {
    value: 'WidgetSubType_FITNESS_DARK_RECT_STEP',
    label: '活动步数-暗色-3218'
  },
  {
    value: 'WidgetSubType_FITNESS_DARK_RECT_CALORIE',
    label: '卡路里-暗色-3219'
  },
  {
    value: 'WidgetSubType_FITNESS_DARK_RECT_STAND',
    label: '站立次数-暗色-3220',
    excludeDevice: ['P67']
  },
  {
    value: 'WidgetSubType_FITNESS_DARK_RECT_ACTIVITY',
    label: '活动时长-暗色-3221'
  },
  {
    // 新增
    value: 'WidgetSubType_FITNESS_DARK_SQUARE_VITALITY',
    label: '活力指标方形-暗色-3201',
    excludeDevice: ['P67']
  },
  {
    value: 'WidgetSubType_HEART_RATE_DARK_RECT_SPLASH',
    label: '心率-暗色-4242',
    excludeDevice: ['P67']
  },
  {
    value: 'WidgetSubType_HEART_RATE_LIGHT_RECT_SPLASH',
    label: '心率-亮色-4498',
    excludeDevice: ['P67']
  },
  {
    value: 'WidgetSubType_SLEEP_DARK_RECT_RESULT',
    label: '睡眠时长-暗色-8337',
    excludeDevice: ['P67']
    // 新增
  },
  {
    value: 'WidgetSubType_SLEEP_DARK_RECT_LONG',
    label: '长睡眠-暗色-8338',
    excludeDevice: ['P67']
  },
  {
    value: 'WidgetSubType_SLEEP_DARK_RECT_STRUCTURE',
    label: '睡眠结构-暗色-8339',
    excludeDevice: ['P67']
    // 新增
  },
  {
    value: 'WidgetSubType_WEATHER_DARK_RECT_WEEK',
    label: '周天气-暗色-10386',
    excludeDevice: ['P67']
    // 新增
  },
  {
    value: 'WidgetSubType_WEATHER_DARK_RECT_HOURLY',
    label: '每小时天气-暗色-10387'
  },
  {
    value: 'WidgetSubType_WEATHER_DARK_RECT_HOURLY_2',
    label: '每小时天气-暗色-10389',
    excludeDevice: []
    // 新增
  },
  {
    value: 'WidgetSubType_WEATHER_DARK_RECT_HOURLY_3',
    label: '每小时天气-暗色-10390',
    excludeDevice: ['P67']
    // 新增
  },
  {
    value: 'WidgetSubType_WEATHER_LIGHT_RECT_HOURLY',
    label: '每小时天气-亮色-10643'
  },
  {
    value: 'WidgetSubType_WEATHER_LIGHT_RECT_SUN',
    label: '日出日落-亮色-10644',
    excludeDevice: ['P67']
  },
  {
    value: 'WidgetSubType_WEATHER_DARK_RECT_SUN',
    label: '日出日落-暗色-10388',
    excludeDevice: ['P67']
  },
  {
    value: 'WidgetSubType_WEATHER_LIGHT_RECT_WEEK',
    label: '周天气-亮色-10642',
    excludeDevice: ['P67']
    // 新增
  },
  {
    value: 'WidgetSubType_BLOOD_OXYGEN_DARK_RECT_SPLASH',
    label: '血氧-暗色-7314',
    excludeDevice: ['P67']
    // 新增
  },

  {
    value: 'WidgetSubType_PRESSURE_DARK_RECT_LINE',
    label: '压力-暗色-6291',
    excludeDevice: ['P67']
    // 新增
  },
  {
    value: 'WidgetSubType_PRESSURE_DARK_RECT_SPLASH',
    label: '压力表情-6290',
    excludeDevice: ['P67']
    // 新增
  },
  {
    value: 'WidgetSubType_CALENDAR_LIGHT_SQUARE_NEXT',
    label: '日程方形-亮色-18817',
    excludeDevice: ['P67']
    // 新增
  },
  {
    value: 'WidgetSubType_CALENDAR_DARK_CIRCLE_DAY',
    label: '日程圆形-暗色-18594',
    excludeDevice: ['P67']
    // 新增
  },
  { value: 'WidgetSubType_CALENDAR_DARK_RECT_NEXT', label: '日程-暗色-18577' },
  {
    value: 'WidgetSubType_CALENDAR_LIGHT_RECT_NEXT',
    label: '日程-亮色-18833',
    excludeDevice: ['P67']
  },

  {
    value: 'WidgetSubType_TIME_KEEPING_DARK_SQUARE_ENTRY',
    label: '倒计时方形-暗色-17537',
    excludeDevice: ['P67']
    // 新增
  },
  {
    value: 'WidgetSubType_TRAINING_STATUS_DARK_SQUARE',
    label: '体能状态方形-暗色-31889'
  },
  {
    value: 'WidgetSubType_WEEKLY_LOAD_DARK_SQUARE',
    label: '本周负荷方形-暗色-31890'
  },
  {
    value: 'WidgetSubType_COMPASS_DARK_SQUARE',
    label: '指南针方形-暗色-30865'
  },
  {
    value: 'WidgetSubType_ALARM_DARK_SQUARE',
    label: '闹钟方形-暗色-25745'
  },
  {
    value: 'WidgetSubType_MUSIC_DARK_SQUARE',
    label: '音乐方形-暗色-14481'
  }
];

const byDeviceAppWidgetOptions = computed(() => {
  const deviceType = watchfaceStore.deviceType;
  const options = ['P62', 'P65', 'P67', 'Q61', 'Q63', 'Q66'].includes(deviceType)
    ? newAppWidgetIDOptions
    : appWidgetIDOptions;
  // 优先级 includeDevice > excludeDevice
  return options.filter((item: any) =>
    item.includeDevice
      ? item.includeDevice.includes(deviceType)
      : !item.excludeDevice?.includes(deviceType)
  );
});

// 预览图
const preview = computed(() => {
  const _preview = props.shape.getResources({
    resourceName: 'appWidgetPreview',
    colorGroup: editorStore.themeColor?.id ?? '',
    base64: true
  });
  return _preview?.[0] ?? '';
});

const onImageUpdate = async (image: string, resourceName: ResourceKey) => {
  props.shape?.uploadResource(
    {
      resourceName,
      colorGroup: editorStore.themeColor?.id ?? '',
      realpath: image
    },
    true
  );
};

const onImageDelete = async (resourceName: ResourceKey) => {
  props.shape?.deleteResource({
    resourceName,
    colorGroup: editorStore.themeColor?.id ?? ''
  });
};
</script>

<style lang="less" scoped></style>
